type TSelectTestItemProps = {
  test: ILabTest;
  setSelectableLabTests: React.Dispatch<React.SetStateAction<ILabTest[]>>;
};
const SelectTestItem = ({
  test,
  setSelectableLabTests,
}: TSelectTestItemProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectableLabTests(prev =>
      prev.map(x => {
        if (x.guid === test.guid) return {...x, selected: event.target.checked};
        return x;
      }),
    );
  };
  return (
    <>
      <div className="pt-3 d-flex">
        <input
          checked={test.selected}
          className="form-check-input"
          type="checkbox"
          id={test.code.toString() + test.input?.code.toString()}
          onChange={handleChange}
        />
        <label
          className="form-check-label pe-2 color-gray-1"
          htmlFor={test.code.toString() + test.input?.code.toString()}
        >
          {test.title}
        </label>
      </div>
    </>
  );
};

export default SelectTestItem;
